"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CleanJson_1 = __importDefault(require("@CommonFrontend/CleanJson/CleanJson"));
var addQuoteDetails = function (quoteBlocksList, acceptData) {
    var configuredQuotes = [];
    var ref = quoteBlocksList.get();
    for (var i = 0, len = ref.length; i < len; i++) {
        var quoteBlock = ref[i];
        var cleanedBlock = (0, CleanJson_1.default)(quoteBlock);
        cleanedBlock.blockId = "" + quoteBlock.blockId;
        configuredQuotes.push(cleanedBlock);
    }
    return (acceptData.configuredQuotes = configuredQuotes);
};
exports.default = addQuoteDetails;
